import React, {Component} from 'react'
import {Modal, Form, Row, Col, Input, Button, message, DatePicker} from 'antd'
import azureAppRegistrationAPI from '../../../apis/azureAppRegistrationAPI'
import {Base64} from 'js-base64'
import moment from 'moment'
import {withTranslation} from 'react-i18next'

class EditModal extends Component {
  formRef = React.createRef()

  componentDidMount() {
    this.getInfoAction()
  }

  getInfoAction = () => {
    const {id} = this.props
    azureAppRegistrationAPI.getInfoAction(id).then(res => {
      this.formRef.current.setFieldsValue({
        applicationName: res.data.data.applicationName,
        applicationClient: res.data.data.applicationClient,
        directoryTenantId: res.data.data.directoryTenantId,
        clientSecret: res.data.data.clientSecret,
        expireDate: moment(res.data.data.expireDate, 'YYYY-MM-DD HH:mm:ss')
      })
    })
  }

  handleOk = () => {
    const {handleCancel, handleSearch, id} = this.props

    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        id: id,
        applicationName: fieldsValue.applicationName,
        applicationClient: fieldsValue.applicationClient,
        directoryTenantId: fieldsValue.directoryTenantId,
        clientSecret: Base64.encode(fieldsValue.clientSecret),
        expireDate: moment(fieldsValue.expireDate).format('YYYY-MM-DD HH:mm:ss')
      }

      azureAppRegistrationAPI.saveAzure(params).then(res => {
        handleCancel('editModalVisible')
        handleSearch()
        message.success('Success!')
      })
    }).catch(err => { })
  }

  render() {
    const {editModalVisible, handleCancel, t} = this.props
    return (
      <>
        <Modal
          title={`${t(`general.edit`)} ${t(`azureAppRegistration.azureAppReg`)}`}
          closable={true}
          visible={editModalVisible}
          onCancel={() => { handleCancel('editModalVisible') }}
          maskClosable={false}
          destroyOnClose={true}
          centered
          width="70%"
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={() => { handleCancel('editModalVisible') }}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="formRef" layout="vertical">
            <Row gutter={[10, 0]}>
              <Col xs={24} sm={24} md={24} lg={24} xl={8} xxl={8} span={8}>
                <Form.Item name="applicationName" label={t(`azureAppRegistration.appName`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`azureAppRegistration.appName`)}`,
                             pattern: new RegExp(/^[^&|;\\\s]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={8} xxl={8} span={8}>
                <Form.Item name="applicationClient" label={t(`azureAppRegistration.applicationClient`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`azureAppRegistration.applicationClient`)}`,
                             pattern: new RegExp(/^[^&|;\\\s]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={8} xxl={8} span={8}>
                <Form.Item name="directoryTenantId" label={t(`azureAppRegistration.directoryTenantId`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`azureAppRegistration.directoryTenantId`)}`,
                             pattern: new RegExp(/^[^&|;\\\s]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={8} xxl={8} span={8}>
                <Form.Item name="clientSecret" label={t(`azureAppRegistration.clientSecret`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`azureAppRegistration.clientSecret`)}`,
                             pattern: new RegExp(/^[^&|;\\\s]*$/)
                           }]}>
                  <Input.Password maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={8} xxl={8} span={8}>
                <Form.Item name="expireDate" label={t(`azureAppRegistration.expireDate`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`azureAppRegistration.expireDate`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <DatePicker
                    showTime={{defaultValue: moment('00:00:00', 'HH:mm:ss')}}
                    format={'YYYY-MM-DD HH:mm:ss'}
                    style={{width: '100%'}}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(EditModal)
